import Colors from "styles/colors";
export const SUBMENU_BORDER = `1px solid ${Colors["dark-marble"]}`;
export const sectionHeaderStyles = `
  font-size: 13px;
  font-weight: 400;
  color: ${Colors["asphalt"]};
  text-transform: uppercase;
  display: flex;
  align-items: center;
  height: 40px;
`;
export const textLinkItemStyles = `
  display: flex;
  align-items: center;
  height: 40px;
  text-decoration: none;

  .item-label {
    font-size: 1rem;
    font-weight: 400;
    color: ${Colors["Black"]};
  }

  &:hover .item-label {
    color: ${Colors["brand-iris"]};
  }
`;
